import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowExpandFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowExpandFilled({
  title = 'Arrow expand',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Arrow expand'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="M21 12V3h-9L9 6h6.9L6 15.9V8.8L3 12v9h9l3-3H8.1L18 8.1v7.1l3-3.2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowExpandFilled;